export default __webpack_public_path__ + "static/1default-c161f01c1d7c24bb6c470462f5918463.png";